export default __webpack_public_path__ + "static/media/hero_image.ede5c84c.jpg";